import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';

/**
 * Weiße Icon-Variante je Menüpunkt. Der aktive Menüpunkt bekommt einen dunklen Hintergrund, auf dem
 * das normale (schwarze) Icon aus dem CSS nicht mehr sichtbar wäre.
 */
const ACTIVE_NAV_ICONS: Readonly<Record<string, string>> = {
  'dashboard-menu-icon': '/assets/app_icon_dashboard_white.svg',
  'performance-menu-icon': '/assets/app_icon_performance_white.svg',
  'schedule-menu-icon': '/assets/app_icon_schedule_white.svg',
  'settings-menu-icon': '/assets/app_icon_settings_white.svg',
};

@Component({
  selector: 'app-bottom-nav',
  imports: [RouterLink],
  templateUrl: './bottom-nav.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bottom-nav.component.css',
})
export class BottomNavComponent implements OnInit, OnDestroy {
  private router = inject(Router);

  private routerSub?: Subscription;

  ngOnInit() {
    // at initial-Load
    this.setActiveMenuIcon();

    // at each navigation change
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setActiveMenuIcon();
      });
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
  }

  private setActiveMenuIcon() {
    const currentUrl = this.router.url;

    // Reset all icons at first
    this.resetAllIcons();

    switch (true) {
      case currentUrl.includes('dashboard'):
        this.styleBottomNavMenuIconColor('dashboard-menu-icon');
        break;
      case currentUrl.includes('energy-chart'):
        this.styleBottomNavMenuIconColor('performance-menu-icon');
        break;
      case currentUrl.includes('settings'):
        this.styleBottomNavMenuIconColor('settings-menu-icon');
        break;
      case currentUrl.includes('schedule'):
        this.styleBottomNavMenuIconColor('schedule-menu-icon');
        break;
      default:
        console.log('Unbekannte Seite: ' + currentUrl);
        break;
    }
  }

  private resetAllIcons() {
    Object.keys(ACTIVE_NAV_ICONS).forEach(id => {
      const element = document.getElementById(id);
      if (element?.parentElement) {
        element.parentElement.style.backgroundColor = '';
        element.parentElement.style.color = '';
        // Leeren, damit wieder die schwarze Variante aus dem CSS greift.
        element.style.backgroundImage = '';
      }
    });
  }

  private styleBottomNavMenuIconColor(id: string) {
    const element = document.getElementById(id);
    if (element?.parentElement) {
      const root = document.documentElement;
      const parent = element.parentElement;

      parent.style.backgroundColor = getComputedStyle(root)
        .getPropertyValue('--color-grid-black')
        .trim();

      parent.style.color = 'white';

      const activeIcon = ACTIVE_NAV_ICONS[id];
      if (activeIcon) {
        element.style.backgroundImage = `url("${activeIcon}")`;
      }
    }
  }
}


